import { apiClient as baseApiClient } from '#/api/client.tsx';
import type { InsurancePolicyType } from '#/service/driver-management/model.ts';
import { InsuranceExpiryReminderListResponseSchema } from '../model.ts';
import type { DateStringValue } from '@mantine/dates';

const cockpitApiClient = baseApiClient.create({
  baseURL: `${import.meta.env.VITE_BASE_URL}/cockpit`,
});

const BASE = '/insurance-expiry-reminders';

export const getInsuranceExpiryReminders = async (accountId: string) => {
  const response = await cockpitApiClient.get(BASE, { params: { accountId } });
  return InsuranceExpiryReminderListResponseSchema.parse(response.data).data;
};

export type CreateInsuranceExpiryReminderParams = {
  accountId: string;
  plateNumber: string;
  policyType: InsurancePolicyType;
  expiryDate: DateStringValue;
  insurer: string;
};

export const createInsuranceExpiryReminder = async (
  params: CreateInsuranceExpiryReminderParams,
) => {
  await cockpitApiClient.post(BASE, params);
};
